export default __webpack_public_path__ + "static/media/Pregunta.cfc4c614.png";